import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import WithImpressions from '../../../WithImpressions';
import { biHelper } from '../../biHelper';
import Education from './Education';
import { degreeTitles } from './const';

export default function EducationList({ educations, biData }) {
    if (!educations.length) { return null; }

    const seller_card_about_me_education_impression = biHelper({
        ...biData,
        group: 'seller_card_about_me_education_impression',
        data: educations
    });

    return (
        <WithImpressions value={seller_card_about_me_education_impression} className="education-list list">
            <h3><I18n k="user_page_perseus.seller_profile.education"/></h3>
            <ul>
                {educations.map((education, idx) => {
                    const degreeTitle = degreeTitles[education.degree_title];

                    const educationData = {
                        degree_title: degreeTitle,
                        ...education
                    };

                    return (<Education education={educationData} key={idx}/>);
                })}
            </ul>
        </WithImpressions>
    );
}

EducationList.propTypes = {
    educations: PropTypes.array,
    biData: PropTypes.object
};

EducationList.defaultProps = {
    educations: [],
    biData: {}
};
